import React from "react";
import sidebar_icon from '../../assets/images/sidebar_icon.svg';
import scatter_plot from '../../assets/images/scatter_plot.svg';
import arrow_back from '../../assets/images/arrow_back.svg';
import { useNavigate } from "react-router-dom";
import '../../assets/css/header.css';

const Header = ({ sidebarOpen, toggleSideBar}) => {
    const navigate = useNavigate();

    const toHomePage = () => {
        navigate(`/start-menu`);
    };

    const sidebarToggleClass = sidebarOpen ? "sidebar-toggle-button selected" : "sidebar-toggle-button";

    return (
        <header className='scatter-header-container'>
            <div className='flex-row' style={{gap: "20px"}}>
                <div className="centered-vertical">
                    <div role="button" className={sidebarToggleClass} onClick={toggleSideBar}>
                        <img src={sidebar_icon}/>
                    </div>
                </div>
                <div id="header-title" className='flex-row' style={{gap: "13px"}}>
                    <h1 className='light no-margin height-auto'>Embedding visualization</h1>
                </div>
            </div>
            <div role="button" className='flex-row' style={{gap: "10px"}} onClick={toHomePage}>
                <img src={arrow_back} style={{width: "15x"}} />
                <span className='font-large light'>Go back</span>
            </div>
        </header>
    );
};

export default Header;